import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';
import { CompetitionCategoryEnum } from '~/apis/ssf';
import { z } from 'zod';

export const querySchema = z
  .object({
    group: z.enum(['ALL', 'CURRENT', 'COMPLETED']).default('CURRENT'),
    search: z.string().default(''),
    districts: z.string().optional(),
    category: z
      .string()
      .transform(s => (s ? (s as CompetitionCategoryEnum) : undefined))
      .optional(),
    to_start_date: z.string().optional(),
    from_end_date: z.string().optional(),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
